




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class GoogleReviews extends Vue {
	@Prop({ default: 0, required: true }) private rating;
	@Prop({ default: 0, required: true }) private total;
	@Prop({ default: [], required: true }) private reviews;
	@Prop({ default: 0, required: false }) private limit;

	private component_reviews = [];

	mounted() {
		if (this.limit) {
			this.component_reviews = this.reviews.slice(0, this.limit)
		} else {
			this.component_reviews = this.reviews;
		}
	}

	get stars() {
		if (this.rating) {
			return Math.floor(this.rating);
		}
		return 0;
	}
}
